export enum VehicleOfferTier {
  BASIC = 'BASIC',
  COMFORT = 'COMFORT',
  PREMIUM = 'PREMIUM',
}

export const getVehicleOfferTierLabel = (tier: VehicleOfferTier): string => {
  switch (tier) {
    case VehicleOfferTier.BASIC:
      return $localize`Basic`;
    case VehicleOfferTier.COMFORT:
      return $localize`Comfort`;
    case VehicleOfferTier.PREMIUM:
      return $localize`Premium`;
    default:
      return '';
  }
};
